require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./quaterlynewsletterapril-2022.json") })
        }
      }, "path---quaterlynewsletterapril-2022");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---quaterlynewsletterapril-2022!./.cache/json/quaterlynewsletterapril-2022.json
// module id = 1189
// module chunks = 231608221292675